import { useCallback, useState } from "react";
import { getDxCodeMapNccn } from "../../../api/postCall/getDXCodeMap";

export const useDxCodeMapRefresh = () => {
  const [isRefreshing, setIsRefreshing] = useState(false);

  const handleRefresh = useCallback(async (orderId: string) => {
    setIsRefreshing(true);
    try {
      await getDxCodeMapNccn({ order_id: orderId });
    } catch (error) {
      console.error("Error refreshing DX Code Map:", error);
    } finally {
      setIsRefreshing(false);
    }
  }, []);

  return { isRefreshing, handleRefresh } as const;
};

export default useDxCodeMapRefresh;
